import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { MatSnackBar } from "@angular/material";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UserService } from "../Services/user.service";
import { Router } from '@angular/router';
import { AppConfig } from '../app.config';
import {environment} from '../../environments/environment';
declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [UserService]
})
export class ChangePasswordComponent implements OnInit {

  //navToUrl: string = AppConfig.settings.apiServer.portalUrl;
  public loading = false;
  newPassword: string;
  oldPassword: string;
  confirmPassword: string;
  passwordChanged: boolean;
  showErrorMsg:boolean;
  portalUrl: string = environment.base_url;
 // portalUrl: string = AppConfig.settings.apiServer.portalUrl;

  constructor(private router: Router, private spinnerService: Ng4LoadingSpinnerService, private snackBar: MatSnackBar, private cookieService: CookieService, private appUserDetails: AppWideUser, private userService: UserService, private token: Token) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.passwordChanged = false;
    this.showErrorMsg=false;
  }

  // ChangePassword() {
  //   if (this.newPassword != "" && this.oldPassword != "" && this.confirmPassword != "") {
  //     if (this.newPassword == this.confirmPassword) {
  //       this.showErrorMsg=false;
  //       this.loading = true;
  //       this.userService.ChangePassword(this.appUserDetails.UserId, this.newPassword, this.oldPassword, this.token, this.appUserDetails.CompanyId).subscribe(x => {
  //         if (x == "success") {
  //           this.loading = false;
  //           this.passwordChanged = true;
  //           this.appUserDetails = new AppWideUser();
  //           this.token = new Token();

  //         }
  //         else {
  //           this.loading = false;
  //           swal({
  //             title: 'Unable to change password',
  //             type: "failure",
  //             showConfirmButton: false
  //           });
  //         }
  //       },
  //         error => {
  //           this.loading = false;
  //           swal({
  //             title: 'Unable to change password',
  //             type: "failure",
  //             showConfirmButton: false
  //           });
  //         });
  //     }
  //     else {
  //       this.showErrorMsg=true;
  //     }
  //   }
  //   else {
  //       swal({
  //             title: 'Please Fill in all the fields',
  //             type: "failure",
  //             showConfirmButton: false
  //           });

  //   }

  // }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }


  // NavigateToLogin() {
  //   this.router.navigate(["http://app.ccpdashboard.com:83/ccpiotportal/login"]);
  // }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/change-password/change-password.component.ts